import { observer } from 'mobx-react-lite';
import { userStore } from 'stores';

import { Login } from './Login';
import { MyWorks } from './MyWorks';
import { Works } from './Works';

export const Home = observer(() => {
	const { isAuth, isStaff, hydrated } = userStore;
	return (isAuth && hydrated) ?
		isStaff ? <Works /> : <MyWorks />
		: <Login />;
});